export const SET_IS_LOADING = "POSTS/SET_IS_LOADING";
export const SET_POST_LIST = "POSTS/SET_POST_LIST";
export const POST_LIST_ADD_ITEM = "POST_LIST_ADD_ITEM";
export const POST_LIST_UPDATE_ITEM = "POST_LIST_UPDATE_ITEM";
export const SET_TOTAL_ITEMS = "LEADS/SET_TOTAL_ITEMS";
